import { utilities } from '../utilities';
import { CONSTANTS } from '../helpers';
class MagnificPopupController {
  constructor() {}
  init() {
    let self = this;

    $('.open-popup-inline')
      .toArray()
      .forEach((el) => {
        $(el).magnificPopup({
          type: 'inline',
        });
      });
    $('.open-popup-rules').magnificPopup({
      // you may add other options here, e.g.:
      preloader: true,

      callbacks: {
        open: function () {
          const element = document.getElementById('game-rules');
          if (!element) return;
          element.scrollIntoView();
        },
        close: function () {},
        // e.t.c.
      },
    });
    $('.open-popup-confidentiality').magnificPopup({
        // you may add other options here, e.g.:
        preloader: true,

        callbacks: {
          open: function () {
            const element = document.getElementById('confidentiality');
            if (!element) return;
            element.scrollIntoView();
          },
          close: function () {},
          // e.t.c.
        },
      });
  }
}
export const controller = new MagnificPopupController();
